<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">店铺</a></el-breadcrumb-item>
          <el-breadcrumb-item>商品信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="product" label-width="160px" size="medium">
        <el-form-item label="商品编码">
          <el-col :span="11">
            <el-input v-model="product.barcode" ></el-input>
          </el-col>
        </el-form-item>   
        <el-form-item label="商品名称">
          <el-col :span="11">
            <el-input v-model="product.name" ></el-input>
          </el-col>
        </el-form-item> 
        <el-form-item label="所属类别">         
          <el-col :span="11">
            <el-input v-model="productCategoryName" readonly placeholder="所属类别">
              <el-button  slot="append" icon="el-icon-search" @click="selectProductCategoryHandle"></el-button>
            </el-input>
          </el-col>    
        </el-form-item>
        <el-form-item label="排序">
          <el-col :span="11">
            <el-input-number v-model="product.sort"  :min="1" :max="10000" label="排序"></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="原价">
          <el-col :span="11">
            <el-input v-model="product.originalPrice"  label="原价">
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="售价">
          <el-col :span="11">
            <el-input v-model="product.price" label="售价">
              <el-button slot="append" >元</el-button>              
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商城展示">
          <el-col :span="11">
            <el-switch
              v-model="product.mallDisplay">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="门店展示">
          <el-col :span="11">
            <el-switch
              v-model="product.storeDisplay">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="Icon图标">
          <el-col :span="11">
            <el-upload
              class="icon-uploader"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :on-success="handleIconSuccess"
              :before-upload="beforeIconUpload">
              <img v-if="product.icon" :src="product.icon" class="icon">
              <i v-else class="el-icon-plus icon-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">请上传1:1大小的图标(如100px*100px)</div>
            </el-upload>
          </el-col>
        </el-form-item>
        <el-form-item label="商品形象图片">
          <el-col :span="20">
            <el-upload
              :action="uploadUrl"
              multiple
              :limit="4"
              :file-list="imagesList"
              :headers="headers"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-success="handlePictureCardSuccess"
              :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">请上传1.6:1大小的图片(如160px*100px)可上传4张</div>
            </el-upload>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="规格" v-if="specifications.length>0">
          <el-col :span="22">
            <div class="sku_container">
              <sku-table :data="specifications" :flatten="skus" @on-change-data="handleChangeData" />
            </div>
          </el-col>
        </el-form-item> -->
        <el-form-item label="分享描述">
          <el-col :span="11">
            <el-input type="textarea" v-model="product.shareDescription"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="描述">
          <editor @showEditor="updateDescription" :content="product.description"></editor>
        </el-form-item>
        <el-form-item >
          <el-col :span="11">
            <el-button type="primary" @click="SaveProduct">保 存</el-button>
            <el-button style="margin-left: 8px" @click="handleBack">返回列表</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>    
    <GetProductCategory v-bind:dialogProductCategory="dialogProductCategory" @UpdateProductCategory="UpdateProductCategory"></GetProductCategory>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  import editor from '@/components/wang-editor';  
  import SkuSelect from '@/components/sku-select'
  import SkuTable from '@/components/sku-table'
  import GetProductCategory from '@/components/GetProductCategory'
  export default {
    props:{
    },
    data (){
      return {
        product:{},
        uploadUrl: this.global.serverSrc+'/api/Common/UploadImage',
        headers:{
          Authorization : sessionStorage.getItem('token')
        },
        skus:[],
        specifications: [],
        dialogProductCategory:{
          isShow:false
        },
        productCategoryName:''
      }
    },
    computed:{
      imagesList:function(){
        var result= [];
        if(this.product.images!=undefined){
          var images = this.product.images.split(',');
          images.forEach(element => {            
            let o=  {
              url:element
            }
            //o.url=element
            result.push(o)
          });
        }        
        return result;
      },     
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/Product/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.product = resp.data.product
        that.productCategoryName = resp.data.productCategoryName
        that.skus = resp.data.skus
        that.specifications = resp.data.specifications
      })
    },
    methods:{     
      SaveProduct:function(){
        var that = this
        that.product.skus = that.skus
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Product/Save',         
          data:that.product
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleIconSuccess(res, file){
        if(res.success){
          this.product.icon= res.fullUrl
        }else {
           this.$message.error(res.message);
        }
      },
      beforeIconUpload(file){
        const isLt2M = file.size / 1024 / 1024 < 2;        
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },
      handleRemove(file, fileList) {
        //console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handlePictureCardSuccess(res,file,fileList){
        if(this.product.images==undefined){
          this.product.images = res.fullUrl
        }else{
          this.product.images += ',' + res.fullUrl;
        }
      },
      updateDescription(data){
        this.product.description=data
      },
      selectProductCategoryHandle(){
        this.dialogProductCategory.isShow = true
      },
      UpdateProductCategory(id,name){
        this.productCategoryName = name
        this.product.categoryId = id
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/ProductCategory/GetSpecifications',         
          params:{
            categoryId:id
          }
        }).then(function (resp) {
          that.specifications = resp.data.specifications  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleChangeData(data){
        this.skus = data
      },
      handleBack(){
        var that = this
        this.$confirm('请先确定已经保存内容！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$router.push({
            name: 'product',
            params: {
              queryParam: that.$route.params.queryParam
            }
          })
        }).catch(() => {
            
        });
      }
    },
    components:{    
      editor,
      SkuSelect,
      SkuTable,
      GetProductCategory
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  import 'element-vue-sku/lib/sku.css'
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
  .icon-uploader
    .el-upload
      border 1px dashed #d9d9d9
      border-radius 6px
      cursor pointer
      position relative
      overflow hidden
      .el-upload
      &:hover
        border-color #409EFF
      img
        width 100px
        height 100px
  .icon-uploader-icon
    font-size 28px
    color #8c939d
    width 100px
    height 100px
    line-height 100px
    text-align center  
  .sku_container
    margin-bottom: 30px
    font-size: 12px
    color: #666
    padding: 10px
    border: 1px solid #e5e5e5
</style>